import List from 'epn-ui/umd/dist/components/List';
import Chips from 'epn-ui/umd/dist/components/Chips';

import clsx from 'clsx';

// Helpers
import useI18n from '@i18n';
import { ISupportDialogCountByStatusAttributes } from '@api/types';

// Config
import { ALL_STATUS, CLOSE_STATUS, OPEN_STATUS } from '../config';

export interface IDialogsStatusesProps {
    countByStatus: ISupportDialogCountByStatusAttributes | Record<string, number>;
    currentStatus: string;
    onAction: (status: string) => void;
}

const DialogsStatuses: React.FC<IDialogsStatusesProps> = ({
    countByStatus,
    currentStatus,
    onAction,
}) => {
    const { t } = useI18n('Support');

    const statusesList = [
        {
            key: ALL_STATUS,
            title: t('All status'),
            count: countByStatus[ALL_STATUS] || 0,
        },
        {
            key: OPEN_STATUS,
            title: t('Open status'),
            count: countByStatus[OPEN_STATUS] || 0,
        },
        {
            key: CLOSE_STATUS,
            title: t('Close status'),
            count: countByStatus[CLOSE_STATUS] || 0,
        },
    ];

    return (
        <>
            <div className="flex flex-wrap mb-[24px] gap-[8px] md:hidden">
                {statusesList.map(item => (
                    <Chips
                        key={item.key}
                        className="flex-1 xs:flex-none min-w-32"
                        id={`support_status_nav_${item.key}`}
                        label={`${item.title} - ${item.count}`}
                        onChange={() => onAction(item.key)}
                        checked={currentStatus === item.key}
                    />
                ))}
            </div>

            <List
                className="hidden md:block"
                size="small"
                dataSource={statusesList}
                renderItem={item => {
                    return (
                        <List.Item
                            onClick={() => onAction(item.key)}
                            className={clsx(
                                'font-normal hover:cursor-pointer hover:bg-blueGray-100  border-b-0',
                                {
                                    'bg-blueGray-100 !text-blueGray-800':
                                        currentStatus === item.key,
                                },
                            )}
                            style={{ borderBlockEnd: '0' }}
                            actions={[<div>{item.count}</div>]}
                        >
                            {item.title}
                        </List.Item>
                    );
                }}
            />
        </>
    );
};

export default DialogsStatuses;
